import { ButtonOLD, HeaderSection, Icon, IconType } from '@lmc/ui-kit'
import Glyph from 'LEGACY/Glyph'
import { ProTag } from 'components/ProTag'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  handleToggleModal: () => void
  handleView: () => void
}

export function CarerSkillsHeaderSection({
  handleView,
  handleToggleModal,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <HeaderSection
      backLink
      onClick={handleView}
      title={
        <div style={styles.flex}>
          {t(`skillsAndNeeds.skillsAndTrainings`)}
          <ProTag />
        </div>
      }
      iconColor="#EFEEFF"
      iconContent={
        <Icon customIcon={IconType.LogoPurple} style={styles.logoIcon} />
      }
      rightChildren={
        <ButtonOLD
          icon={
            <Glyph
              name="plus"
              aphroditeStyles={undefined}
              className={undefined}
              color={undefined}
              component={undefined}
              size={undefined}
              style={undefined}
            />
          }
          type="primary"
          onClick={handleToggleModal}
        >
          {t(`skillsAndNeeds.assignNewSkillButton`)}
        </ButtonOLD>
      }
    />
  )
}

const styles = {
  logoIcon: {
    width: 26,
    height: 26,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
}

export default CarerSkillsHeaderSection
